import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { PARTNER_LINK } from "@/lib/constants";

const MobileStickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.7);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      aria-hidden={!visible}
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-border/60 bg-background/95 backdrop-blur-md px-3 py-2.5 shadow-[0_-4px_16px_rgba(0,0,0,0.25)] transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <a
        href={PARTNER_LINK}
        target="_blank"
        rel="sponsored noopener noreferrer"
        onClick={() => window.lh?.trackAffiliate({ source: "sticky_mobile" })}
        className="flex w-full items-center justify-center gap-1.5 rounded-lg bg-primary px-3 py-3 text-sm font-semibold text-primary-foreground shadow-md shadow-primary/25 transition-all hover:brightness-110"
      >
        Zum offiziellen heilys Shop
        <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
      </a>
    </div>
  );
};

export default MobileStickyCTA;
